import { render, staticRenderFns } from "./FYLZRecordList.vue?vue&type=template&id=2f4fd61a&scoped=true&"
import script from "./FYLZRecordList.vue?vue&type=script&lang=js&"
export * from "./FYLZRecordList.vue?vue&type=script&lang=js&"
import style0 from "./FYLZRecordList.vue?vue&type=style&index=0&id=2f4fd61a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4fd61a",
  null
  
)

export default component.exports